import { EventApi } from '@fullcalendar/core';
import { ItemServico } from 'src/app/admihair/api/dto/item-servico';

export type AgendaStatus =
  | 'AGENDADO'
  | 'CONFIRMADO'
  | 'ATENDIDO'
  | 'FALTOU'
  | 'CANCELADO';


export interface EventColors {
  background: string;
  border: string;
  text: string;
}

export const BLOQUEIO_COLORS: EventColors = {
  background: '#ECEFF1',
  border: '#607D8B',
  text: '#263238'
};

export const AGENDA_STATUS_COLORS: Record<AgendaStatus, EventColors> = {
  AGENDADO: {
    background: '#E3F2FD',
    border: '#2196F3',
    text: '#0D47A1'
  },
  CONFIRMADO: {
    background: '#E8F5E9',
    border: '#4CAF50',
    text: '#1B5E20'
  },
  ATENDIDO: {
    background: '#F3E5F5',
    border: '#9C27B0',
    text: '#4A148C'
  },
  FALTOU: {
    background: '#FFF3E0',
    border: '#FF9800',
    text: '#E65100'
  },
  CANCELADO: {
    background: '#FFEBEE',
    border: '#F44336',
    text: '#B71C1C'
  }
};

export function obterEstiloStatus(status?: string | null) {
    if (!status) {
      return {
        backgroundColor: '#E0E0E0',
        borderColor: '#BDBDBD',
        color: '#424242'
      };
    }

    const colors = AGENDA_STATUS_COLORS[status as AgendaStatus];

    if (colors) {
      return {
        backgroundColor: colors.background,
        borderColor: colors.border,
        color: colors.text
      }
    }
    return {
      backgroundColor: '#E0E0E0',
      borderColor: '#BDBDBD',
      color: '#424242'
    };
  }


export function isEventoCompacto(event: EventApi, limiteMinutos = 15): boolean {
  return calcularDuracaoEmMinutos(event) <= limiteMinutos;
}

export function calcularDuracaoEmMinutos(event: EventApi): number {
  if (!event.start || !event.end) {
    return 0;
  }
  return (event.end.getTime() - event.start.getTime()) / 60000;
}


export function calcularHoraFimAgendamento2(horaInicio?: string, servicos?: ItemServico[]): string | undefined {
  console.log(horaInicio)
  if (!horaInicio || !servicos?.length) {
    return;
  }
  let totalMinutos = 0;
  for (const item of servicos) {
    if (item.tempoMedio) {
      const [horas, minutos] = item.tempoMedio.split(':').map(Number);
      totalMinutos += (horas * 60) + minutos;
    }
  }
  const dataFim = new Date(horaInicio);
  dataFim.setMinutes(dataFim.getMinutes() + totalMinutos);
  return dataFim.toTimeString().split(' ')[0];
}

export function calcularHoraFimAgendamento(horaInicio?: string, servicos?: ItemServico[]): string | undefined {
  if (!horaInicio || !servicos?.length) {
    return;
  }

  const [hInicio, mInicio] = horaInicio.split(':').map(Number);

  let totalMinutosServicos = 0;
  for (const item of servicos) {
    if (item.tempoMedio) {
      const [horas, minutos] = item.tempoMedio.split(':').map(Number);
      totalMinutosServicos += (horas * 60) + minutos;
    }
  }

  const dataFim = new Date();
  dataFim.setHours(hInicio, mInicio, 0, 0);

  dataFim.setMinutes(dataFim.getMinutes() + totalMinutosServicos);

  const horas = String(dataFim.getHours()).padStart(2, '0');
  const minutos = String(dataFim.getMinutes()).padStart(2, '0');
  const segundos = String(dataFim.getSeconds()).padStart(2, '0');

  return `${horas}:${minutos}:${segundos}`;
}
